import React, { useEffect, useState } from "react";
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox, CircularProgress, Box, Typography, Button, Select, MenuItem, Pagination } from "@mui/material";
import axios from "axios";
import { PartnerArrowIcon } from "../../res/NewWebIcons";

const PayoutCheckCharges = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  // ✅ API Call to Fetch Data
  const fetchData = async () => {
    setLoading(true);
    const token = sessionStorage.getItem("jwtToken");
    try {
      const response = await axios.get("https://api.ipaisa.co.in/myapp/admin/checkChargesList", {
        headers: {
            Authorization: `Bearer${token}`
          },
          params: {
              page: currentPage,  // Current page number
              size: pageSize      // Page size
          }
      });
      if (response.status === 200) {
        setData(response.data.body.data);
        setTotalRecords(response.data.body.totalElements); 
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ API Call to Update Charges Status
  const updateChargesStatus = async (userId) => {
    setUpdating(userId);
    const token = sessionStorage.getItem("jwtToken");
    try {
      const response = await axios.put(
        `https://api.ipaisa.co.in/myapp/admin/updateChargesStatus?userId=${userId}`,
        {},
        {
          headers: {
            Authorization: `Bearer${token}`
          }
        }
      );
      if (response.status === 200) {
        fetchData();
      }
    } catch (error) {
      console.error("Error updating charges status:", error);
    } finally {
      setUpdating(null);
    }
  };

  useEffect(() => {
    fetchData(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value - 1);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setCurrentPage(0);
  };

  return (
    <Box style={{ padding: "2rem", marginTop: "calc(3% + 56px)" }}>
        <Grid
            style={{
            display: "flex",
            alignItems: "center",
            gap: "1%",
            justifyContent: "start",
            }}
        >
            <Typography
            color="textSecondary"
            style={{ fontFamily: "sans-serif", fontSize: "14px" }}
            >
            Report
            </Typography>
            <PartnerArrowIcon />
            <Typography
            color="textSecondary"
            style={{ fontFamily: "sans-serif", fontSize: "14px" }}
            >
            Payout Check Charges
            </Typography>
        </Grid>
        <Grid style={{ marginTop: "2%" }}>
            <Typography
            style={{
                fontWeight: "bold",
                fontFamily: "sans-serif",
                fontSize: "19px",
                color: "#343C6A",
            }}
            >
            Payout Check Charges
            </Typography>
        </Grid>
        <Grid style={{ marginTop: "3%" }}>
            {loading ? (
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                style={{ height: "100vh" }}
              >
                <CircularProgress />
              </Grid>            
        ) : (
                    <TableContainer
                            component={Paper}
                            sx={{
                            maxWidth: "100%",
                            overflowX: "auto",
                            borderRadius: "12px 12px 0px 0px",
                            }}
                        >
                        <Table>
                        <TableHead style={{ backgroundColor: "#027BFE", color: "white" }}>
                        <TableRow>
                            <TableCell sx={{color:"white"}}>Sr. No.</TableCell>
                            <TableCell sx={{color:'white'}}>Parent ID</TableCell>
                            <TableCell sx={{color:'white'}}>User ID</TableCell>
                            <TableCell sx={{color:'white'}}>Name</TableCell>
                            <TableCell sx={{color:'white'}}>Mobile</TableCell>
                            <TableCell sx={{color:'white'}}>User Status</TableCell>
                            <TableCell sx={{color:'white'}}>Payout Status</TableCell>
                            <TableCell sx={{color:'white'}}>Charges Status</TableCell>
                            <TableCell sx={{color:'white'}}>Action</TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {data.length === 0 ? (
                            <TableRow>
                            <TableCell colSpan={6} align="center">No records found</TableCell>
                            </TableRow>
                        ) : (
                            data.map((user, index) => (
                            <TableRow key={user.userid}>
                                <TableCell>
                                  {currentPage * pageSize + index + 1}
                                </TableCell>
                                <TableCell>{user.parentId}</TableCell>
                                <TableCell>{user.userid}</TableCell>
                                <TableCell>{user.firstName} {user.lastName}</TableCell>
                                <TableCell>{user.mobileNumber}</TableCell>
                                <TableCell>{user.status}</TableCell>
                                <TableCell>{user.payoutStatus}</TableCell>
                                <TableCell>{user.chkCharges}</TableCell>
                                <TableCell>
                                    <Button
                                        variant="contained"
                                        onClick={() => updateChargesStatus(user.userid)}
                                        disabled={updating === user.userid}
                                        style={{ 
                                            width: '80%', 
                                            height: '40px', 
                                            backgroundColor: '#027BFE', // Unique blue shade
                                            color: '#FFFFFF', // White text
                                            fontWeight: 'bold' ,
                                            textTransform: 'none', 
                                        }}
                                    >
                                        {updating === user.userid ? <CircularProgress size={20} color="inherit" /> : "Set Charges"}
                                    </Button>
                                </TableCell>
                            </TableRow>
                            ))
                        )}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Grid>
                  {/* Pagination */}
              <Grid container spacing={2} justifyContent="space-between" alignItems="center" style={{marginTop:'1%'}}>
              <Grid item>
                  <Select variant="outlined" value={pageSize} onChange={handlePageSizeChange}>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={25}>25</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                  </Select>
                  <Typography display="inline" style={{ marginLeft: 8 }}>
                      Showing {currentPage * pageSize + 1} to {Math.min((currentPage + 1) * pageSize, totalRecords)} out of {totalRecords} records
                  </Typography>
              </Grid>
              <Grid item>
                  <Pagination count={Math.ceil(totalRecords / pageSize)} color="primary" page={currentPage + 1} onChange={handlePageChange} />
              </Grid>
          </Grid>
    </Box>
  );
};

export default PayoutCheckCharges;
